"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _constant = require("@airasia/phoenix-components/components/constant");

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));

var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));

var _MobileDropdown = _interopRequireDefault(require("@airasia/phoenix-components/components/MobileDropdown"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Title = _interopRequireDefault(require("@airasia/phoenix-components/components/Title"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constant2 = require("../constant");

var _HamburgerMenu = _interopRequireDefault(require("../HamburgerMenu"));

var _LocaleCurrency = _interopRequireDefault(require("../LocaleCurrency"));

var _Login = _interopRequireDefault(require("../Login"));

var _WebVitalRUM = _interopRequireDefault(require("@airasia/phoenix-components/components/WebVitalRUM"));

var _MobileHeaderNavigationMenu = _interopRequireDefault(require("../MobileHeaderNavigationMenu"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _universalheader = require("./universalheader.proptypes");

var _constants = require("./constants");

var _universalheader2 = _interopRequireDefault(require("./universalheader.util"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__Container",
  componentId: "sc-rfcunp-0"
})(["display:flex;justify-content:space-between;align-items:center;box-shadow:0px 2px 6px rgba(0,0,0,0.2);padding:", ";height:64px;background-color:", ";"], function (props) {
  return props.customPadding ? props.customPadding : '0px 80px';
}, function (props) {
  return props.theme.backgroundColor[props.background];
});

var A11ySkipContent = _styledComponents.default.span.withConfig({
  displayName: "UniversalHeader__A11ySkipContent",
  componentId: "sc-rfcunp-1"
})(["position:absolute;right:0;h2{font-size:", ";color:", ";opacity:0;width:", ";height:", ";overflow:hidden;&:focus{color:", ";opacity:1;width:auto;height:auto;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize.normal;
}, function (props) {
  return props.theme.backgroundColor[props.background];
}, _constants.A11Y_DIMENTIONS, _constants.A11Y_DIMENTIONS, function (props) {
  return props.theme.colors[props.color];
});

var ImageContainer = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__ImageContainer",
  componentId: "sc-rfcunp-2"
})(["display:flex;align-items:center;width:148px;height:100%;cursor:pointer;& img{max-width:100%;max-height:100%;min-width:1px;}& #header-logo-container{max-height:100%;height:100%;display:flex;align-items:center;}"]);

var LocaleCurrencyContainer = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__LocaleCurrencyContainer",
  componentId: "sc-rfcunp-3"
})(["border-left:2px solid ", ";border-right:2px solid ", ";padding:8px 16px;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray;
});

var MobileHeader = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__MobileHeader",
  componentId: "sc-rfcunp-4"
})(["position:relative;z-index:11;display:flex;align-items:center;width:100%;padding:0 1rem;box-sizing:border-box;background-color:", ";height:3.125rem;box-shadow:0px 4px 4px rgba(0,0,0,0.08);"], function (props) {
  return props.theme.backgroundColor[props.background];
});

var MobileHeaderItem = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__MobileHeaderItem",
  componentId: "sc-rfcunp-5"
})(function (_ref4) {
  var justifyContent = _ref4.justifyContent;
  return "\n      display: flex;\n      justify-content: ".concat(justifyContent, ";\n      align-items: center;\n      width: 100%;\n      height: 100%;\n      flex: 1;\n\n    & #header-mobile-header-profile{\n      display: flex;\n      justify-content: ").concat(justifyContent, ";\n      align-items: center;\n    }\n  ");
});

var OTAMobileHeader = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__OTAMobileHeader",
  componentId: "sc-rfcunp-6"
})(["position:relative;z-index:11;align-items:center;width:100%;box-sizing:border-box;background-color:", ";"], function (props) {
  return props.theme.backgroundColor[props.background];
});

var CustomHeadingContainer = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__CustomHeadingContainer",
  componentId: "sc-rfcunp-7"
})(["display:flex;justify-content:flex-start;flex-direction:row;"]);

var CustomHeadingBody = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__CustomHeadingBody",
  componentId: "sc-rfcunp-8"
})(["display:flex;padding-left:", ";align-self:center;"], function (props) {
  return props.theme.space.XSmall;
});

var CustomHeadingIcon = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__CustomHeadingIcon",
  componentId: "sc-rfcunp-9"
})(["display:flex;align-self:center;"]);

var MobileLocaleCurrencyContainer = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__MobileLocaleCurrencyContainer",
  componentId: "sc-rfcunp-10"
})(["& #header-mobile-header-modal{right:-100%;left:auto;transition:ease-in-out 0.2s;}&.open{#header-mobile-header-modal{right:0;}}"]);

var LeftContainer = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__LeftContainer",
  componentId: "sc-rfcunp-11"
})(["position:relative;align-items:center;display:flex;justify-content:flex-start;flex:1;height:100%;"]);

var RightContainer = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__RightContainer",
  componentId: "sc-rfcunp-12"
})(["justify-content:flex-end;position:relative;display:flex;align-items:center;height:100%;"]);

var LeftRightDesktopModule = (0, _styledComponents.css)(["display:flex;text-align:center;align-items:center;position:relative;height:100%;"]);

var LeftModule = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__LeftModule",
  componentId: "sc-rfcunp-13"
})(["", " margin-right:24px;"], LeftRightDesktopModule);

var RightModule = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__RightModule",
  componentId: "sc-rfcunp-14"
})(["", " margin-left:24px;"], LeftRightDesktopModule);

var CustomLink = (0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "UniversalHeader__CustomLink",
  componentId: "sc-rfcunp-15"
})([":hover{color:", ";text-decoration:none;}:active{color:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors[_constants.DEFAULT_STYLE.DEFAULT_TEXT_HOVER_COLOR];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors[_constants.DEFAULT_STYLE.DEFAULT_TEXT_ACTIVE_COLOR];
});

var LoginWrapper = _styledComponents.default.div.withConfig({
  displayName: "UniversalHeader__LoginWrapper",
  componentId: "sc-rfcunp-16"
})(["display:", ";align-items:", ";"], function (_ref7) {
  var isHide = _ref7.isHide;
  return isHide ? 'none' : 'flex';
}, function (_ref8) {
  var isHide = _ref8.isHide;
  return !isHide && 'center';
});

var renderDesktopNavLink = function renderDesktopNavLink(href, label, accessible, color, gtmEventData, fireGtm, callback) {
  var isCallback = typeof callback === 'function';
  return /*#__PURE__*/_react.default.createElement(CustomLink, {
    type: isCallback ? 'secured' : 'normal',
    href: isCallback ? '#' : href,
    color: color,
    accessible: accessible,
    gtmEventData: gtmEventData,
    fireGtm: fireGtm,
    target: isCallback ? 'callback' : 'tab',
    callback: isCallback ? callback : function () {},
    customProperties: {
      'aria-label': "".concat(label, ". Actionable Left click or press enter to access.")
    },
    idConfig: {
      parentName: 'universalHeader',
      widgetName: gtmEventData
    }
  }, label);
};

var renderHeaderLogo = function renderHeaderLogo(theme, iconUrl, accessible, background, width, height) {
  return /*#__PURE__*/_react.default.createElement(_Image.default, {
    accessible: accessible,
    centerFocus: false,
    alt: "logo",
    src: iconUrl,
    theme: theme,
    placeHolderBackground: background,
    width: width !== null && width !== void 0 ? width : 'auto',
    height: height !== null && height !== void 0 ? height : 'auto',
    customProperties: {
      id: 'header-logo-container'
    }
  });
};

var handleLocaleChange = function handleLocaleChange(locale) {
  _universalheader2.default.createCookie(_constants.LOCALE_COOKIE_LABEL, locale, _constants.LOCAL_CURRENCY_EXPIRY);

  window.dispatchEvent(new CustomEvent('uhfLocaleChange', {
    detail: locale
  }));
};

var handleCurrencyChange = function handleCurrencyChange(currency) {
  _universalheader2.default.createCookie(_constants.CURRENCY_COOKIE_LABEL, currency, _constants.LOCAL_CURRENCY_EXPIRY);

  window.dispatchEvent(new CustomEvent('uhfCurrencyChange', {
    detail: currency
  }));
};

var handleOTAEditCTA = function handleOTAEditCTA() {
  window.dispatchEvent(new CustomEvent('uhfOTAEdit'));
};

var renderLoginComponent = function renderLoginComponent(data, loginLabel, iconType, theme, accessible, locale, currency, viewport, environment, loginConfig, direction, onUserLoginStatus, isScrollTop, isHide, secretKey, getInfoConfigTokens, move, jwtToken) {
  var loginMenu = data.loginMenu,
      loginTooltip = data.loginTooltip;
  var shouldSetCookie = loginConfig.shouldSetCookie,
      enableBigPoints = loginConfig.enableBigPoints,
      enableFavoriteMembers = loginConfig.enableFavoriteMembers,
      enableCreditBalance = loginConfig.enableCreditBalance,
      reloadOnLogin = loginConfig.reloadOnLogin,
      reloadOnLogout = loginConfig.reloadOnLogout,
      HideLoginIconForMobile = loginConfig.HideLoginIconForMobile,
      setDuplicateCookieAATokens = loginConfig.setDuplicateCookieAATokens,
      isLoginMandated = loginConfig.isLoginMandated,
      callCreditEndpointV2 = loginConfig.callCreditEndpointV2,
      enableGuestLogin = loginConfig.enableGuestLogin;
  var localeArr = locale.split('-');
  var formattedLocale = "".concat(localeArr[0], "-").concat(localeArr[1].toUpperCase());
  var showTooltip = true;

  var tooltipAlreadyShowed = _utilities.default.getCookie(_constants.LOGIN_TOOLTIP_SHOWED_SESSION_LABEL);

  if (tooltipAlreadyShowed) {
    showTooltip = false;
  }

  return /*#__PURE__*/_react.default.createElement(LoginWrapper, {
    id: "home_login_signup",
    isHide: isHide
  }, /*#__PURE__*/_react.default.createElement(_Login.default, {
    jwtToken: jwtToken,
    loginLabel: loginLabel,
    iconType: iconType,
    deviceType: viewport,
    loginMenuData: loginMenu,
    theme: theme,
    enableBigPoints: enableBigPoints,
    enableFavoriteMembers: enableFavoriteMembers,
    enableCreditBalance: enableCreditBalance,
    environment: environment,
    tooltipdata: loginTooltip,
    accessible: accessible,
    locale: formattedLocale,
    currency: currency,
    HideLoginIconForMobile: HideLoginIconForMobile,
    shouldSetCookie: shouldSetCookie,
    reloadOnLogin: reloadOnLogin,
    reloadOnLogout: reloadOnLogout,
    setDuplicateCookieAATokens: setDuplicateCookieAATokens,
    MenuOnLeft: direction === _constants.DIRECTION.LEFT,
    customProperties: {
      id: 'login-component'
    },
    onUserLoginStatus: onUserLoginStatus,
    shouldShowTooltip: showTooltip,
    isScrollTop: isScrollTop,
    secretKey: secretKey,
    isLoginMandated: isLoginMandated,
    getInfoConfigTokens: getInfoConfigTokens,
    callCreditEndpointV2: callCreditEndpointV2,
    textColor: move,
    enableGuestLogin: enableGuestLogin
  }));
};

var renderLocaleCurrency = function renderLocaleCurrency(theme, data, locale, currency, accessible, dropdownPosition, viewport, icon, color, showCurrency, showLocale, fireGtm, gtmParameters, move) {
  var defaultLocale = data.defaultLocale,
      defaultCurrency = data.defaultCurrency,
      recommendedCurrencyList = data.recommendedCurrencyList,
      currencyList = data.currencyList,
      recommendedLocaleList = data.recommendedLocaleList,
      localeList = data.localeList,
      translations = data.translations;

  var _ref9 = gtmParameters || {},
      eventLabelLocaleCurrency = _ref9.eventLabelLocaleCurrency,
      eventLabelLocale = _ref9.eventLabelLocale,
      eventLabelCurrency = _ref9.eventLabelCurrency;

  return /*#__PURE__*/_react.default.createElement(LocaleCurrencyContainer, null, /*#__PURE__*/_react.default.createElement(_LocaleCurrency.default, {
    theme: theme,
    accessible: accessible,
    dropdownPosition: dropdownPosition,
    device: viewport,
    icon: icon,
    showCurrency: showCurrency && defaultCurrency !== undefined && currencyList !== undefined,
    showLocale: showLocale && defaultLocale !== undefined && localeList !== undefined,
    defaultCurrency: !currency ? defaultCurrency.find(function (item) {
      return item.data;
    }).data[0].shortform : currency,
    defaultLocale: !locale ? defaultLocale.find(function (item) {
      return item.data;
    }).data[0].default : locale,
    currencyList: currencyList && currencyList.find(function (item) {
      return item.data;
    }).data,
    localeList: localeList && localeList.find(function (item) {
      return item.data;
    }).data,
    recommendedCurrencyList: recommendedCurrencyList && recommendedCurrencyList.find(function (item) {
      return item.data;
    }) && recommendedCurrencyList.find(function (item) {
      return item.data;
    }).data,
    recommendedLocaleList: recommendedLocaleList && recommendedLocaleList.find(function (item) {
      return item.data;
    }) && recommendedLocaleList.find(function (item) {
      return item.data;
    }).data,
    labelConfig: translations.find(function (item) {
      return item.data;
    }).data[0],
    onLocaleChange: handleLocaleChange,
    onCurrencyChange: handleCurrencyChange,
    dropdownConfig: {
      headerConfig: {
        normalColor: color
      },
      fireGtm: fireGtm,
      gtmEventData: eventLabelLocaleCurrency
    },
    modalConfig: {
      zIndex: 999
    },
    fireGtm: fireGtm,
    gtmLocaleEventData: eventLabelLocale,
    gtmCurrencyEventData: eventLabelCurrency,
    move: move
  }));
};

var handleImageClick = function handleImageClick(e, isNewTab, redirectUrl) {
  e.preventDefault();

  if (window !== 'undefined') {
    if (isNewTab === 'TRUE' || isNewTab === '') {
      window.open(redirectUrl, '_blank');
    } else {
      window.open(redirectUrl, '_self');
    }
  }
};

var MobileUniversalHeader = function MobileUniversalHeader(props) {
  var data = props.data,
      mobileDataInsideLeftPane = props.mobileDataInsideLeftPane,
      background = props.background,
      color = props.color,
      accessible = props.accessible,
      currency = props.currency,
      locale = props.locale,
      theme = props.theme,
      loginConfig = props.loginConfig,
      viewport = props.viewport,
      environment = props.environment,
      onUserLoginStatus = props.onUserLoginStatus,
      gtmParameters = props.gtmParameters,
      fireGtm = props.fireGtm,
      showCurrency = props.showCurrency,
      showLocale = props.showLocale,
      showChangeCurrency = props.showChangeCurrency,
      children = props.children,
      idConfig = props.idConfig,
      customHeadingEnabled = props.customHeadingEnabled,
      customHeading = props.customHeading,
      customOTAHeaderEnabled = props.customOTAHeaderEnabled,
      OTAHeaderData = props.OTAHeaderData,
      OTABackIconCallback = props.OTABackIconCallback,
      logoWidth = props.logoWidth,
      logoHeight = props.logoHeight,
      secretKey = props.secretKey,
      getInfoConfigTokens = props.getInfoConfigTokens,
      headerTextLimit = props.headerTextLimit,
      hasBoxShadow = props.hasBoxShadow,
      move = props.move,
      jwtToken = props.jwtToken;
  var components = data.components,
      defaultLocale = data.defaultLocale,
      defaultCurrency = data.defaultCurrency,
      localeList = data.localeList,
      currencyList = data.currencyList,
      recommendedLocaleList = data.recommendedLocaleList,
      recommendedCurrencyList = data.recommendedCurrencyList,
      translations = data.translations;

  var _ref10 = idConfig || {},
      parentName = _ref10.parentName,
      widgetName = _ref10.widgetName,
      index = _ref10.index;

  var _useState = (0, _react.useState)('universalHeader'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dynamicID = _useState2[0],
      setId = _useState2[1];

  (0, _react.useEffect)(function () {
    var url = 'universalHeader';

    if (parentName) {
      url = "".concat(parentName, "-universalHeader");
    }

    if (index) {
      url += "-".concat(index);
    }

    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }

    setId(url);
  }, [widgetName, parentName, index]);

  var _ref11 = gtmParameters || {},
      eventLabelLocaleCurrency = _ref11.eventLabelLocaleCurrency,
      eventLabelLocale = _ref11.eventLabelLocale,
      eventLabelCurrency = _ref11.eventLabelCurrency;

  var comp = components.find(function (el) {
    return el.data;
  }).data;

  var defaultLoc = _universalheader2.default.getData(defaultLocale) && _universalheader2.default.getData(defaultLocale)[0];

  var defaultCurr = _universalheader2.default.getData(defaultCurrency) && _universalheader2.default.getData(defaultCurrency)[0];

  var localeListData = _universalheader2.default.getData(localeList);

  var currencyListData = _universalheader2.default.getData(currencyList);

  var recommendedLocaleListData = _universalheader2.default.getData(recommendedLocaleList);

  var recommendedCurrencyListData = _universalheader2.default.getData(recommendedCurrencyList);

  var translationsData = _universalheader2.default.getData(translations) && _universalheader2.default.getData(translations)[0];

  var logo = comp.find(function (c) {
    return c.type === _constants.HEADER_COMPONENTS.LOGO;
  });
  var login = comp.find(function (c) {
    return c.type === _constants.HEADER_COMPONENTS.LOGIN;
  });
  var changeCurrency = showChangeCurrency;
  /* comp.find((c) => c.type === HEADER_COMPONENTS.CHANGE_CURRENCY); */

  var mobileHeaderComps = comp.filter(function (c) {
    return c.type === _constants.HEADER_COMPONENTS.CUSTOM_COMPONENTS && c.showInMobileHeader === 'TRUE';
  });
  var aggregatedLocaleList = [].concat((0, _toConsumableArray2.default)(recommendedLocaleListData || []), (0, _toConsumableArray2.default)(localeListData || []));
  var aggregatedCurrencyList = [].concat((0, _toConsumableArray2.default)(recommendedCurrencyListData || []), (0, _toConsumableArray2.default)(currencyListData || []));

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      menuClick = _useState4[0],
      setMenuClick = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectedMenu = _useState6[0],
      setSelectedMenu = _useState6[1];

  var _useState7 = (0, _react.useState)(locale),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      selectedLocale = _useState8[0],
      setSelectedLocale = _useState8[1];

  var _useState9 = (0, _react.useState)(currency),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      selectedCurrency = _useState10[0],
      setSelectedCurrency = _useState10[1];

  var mobileDropdownRef = (0, _react.useRef)(null);

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      mobileDropdownHeaderLabel = _useState12[0],
      setMobileDropdownHeaderLabel = _useState12[1];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      mobileDropdownSections = _useState14[0],
      setMobileDropdownSections = _useState14[1];

  var _useState15 = (0, _react.useState)(null),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      defaultSelectedOption = _useState16[0],
      setDefaultSelectedOption = _useState16[1];

  var hamburgerNavigation = _universalheader2.default.generateNavigationSection(mobileDataInsideLeftPane);

  var onLocaleMenuClick = function onLocaleMenuClick() {
    setSelectedMenu(_constants.LOCALE_LABEL);
    setMenuClick(true);
    setMobileDropdownHeaderLabel(translationsData.mobileLocaleLabel);
    setDefaultSelectedOption(selectedLocale);
    setMobileDropdownSections(_universalheader2.default.generateMobileDropdownSection(recommendedLocaleListData, localeListData, _constants.LOCALE_LABEL, translationsData, color));

    if (fireGtm && eventLabelLocaleCurrency) {
      var newData = eventLabelLocaleCurrency.replace('{{label}}', _constants.HAMBURGER_VALUES.LOCALE);
      fireGtm(newData);
    }
  };

  var onCurrencyMenuClick = function onCurrencyMenuClick() {
    setSelectedMenu(_constants.CURRENCY_LABEL);
    setMenuClick(true);
    setMobileDropdownHeaderLabel(translationsData.mobileCurrencyLabel);
    setDefaultSelectedOption(selectedCurrency);
    setMobileDropdownSections(_universalheader2.default.generateMobileDropdownSection(recommendedCurrencyListData, currencyListData, _constants.CURRENCY_LABEL, translationsData, color));

    if (fireGtm && eventLabelLocaleCurrency) {
      var newData = eventLabelLocaleCurrency.replace('{{label}}', _constants.HAMBURGER_VALUES.CURRENCY);
      fireGtm(newData);
    }
  };

  (0, _react.useEffect)(function () {
    if (selectedMenu === _constants.LOCALE_LABEL) {
      setMobileDropdownSections(_universalheader2.default.generateMobileDropdownSection(recommendedLocaleListData, localeListData, _constants.LOCALE_LABEL, translationsData, color));
    } else if (selectedMenu === _constants.CURRENCY_LABEL) {
      setMobileDropdownSections(_universalheader2.default.generateMobileDropdownSection(recommendedCurrencyListData, currencyListData, _constants.CURRENCY_LABEL, translationsData, color));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [color]);

  var closeMobileDropdown = function closeMobileDropdown() {
    if (mobileDropdownRef && mobileDropdownRef.current) {
      mobileDropdownRef.current.classList.remove('open');
    }

    if (typeof document !== 'undefined') {
      document.getElementById('header-mobile-header-modal').addEventListener('transitionend', function () {
        return setMenuClick(false);
      });
    }
  };

  var setLoginConfigForCurrency = function setLoginConfigForCurrency(config, hideIcon) {
    // added setting of HideLoginIconForMobile value to the hideIcon value
    if (hideIcon) {
      config.HideLoginIconForMobile = hideIcon;
    }

    return config;
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('closeMobileCurrency', closeMobileDropdown);
    }

    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('closeMobileCurrency', closeMobileDropdown) : null;
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (menuClick) {
      if (mobileDropdownRef && mobileDropdownRef.current) {
        mobileDropdownRef.current.classList.add('open');
      }

      if (typeof document !== 'undefined') {
        // Remove existing eventlistener
        document.getElementById('header-mobile-header-modal').removeEventListener('transitionend', function () {
          return setMenuClick(false);
        });
      }
    }
  }, [menuClick]);

  var _useState17 = (0, _react.useState)(_universalheader2.default.generateLocaleCurrencyNavigationSection(mobileDataInsideLeftPane, defaultLoc, defaultCurr, onLocaleMenuClick, onCurrencyMenuClick, defaultLoc && defaultLoc.icon, defaultCurr && defaultCurr.icon, translationsData, showLocale, showCurrency)),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      hamburgerLocaleCurrency = _useState18[0],
      setHamburgerLocaleCurrency = _useState18[1];

  (0, _react.useEffect)(function () {
    setSelectedLocale(locale);
  }, [locale]);
  (0, _react.useEffect)(function () {
    setSelectedCurrency(currency);
  }, [currency]);
  (0, _react.useEffect)(function () {
    var localeObj = aggregatedLocaleList && aggregatedLocaleList.find(function (loc) {
      return loc.default === selectedLocale;
    });
    var currencyObj = aggregatedCurrencyList && aggregatedCurrencyList.find(function (loc) {
      return loc.shortform === selectedCurrency;
    });
    setHamburgerLocaleCurrency(_universalheader2.default.generateLocaleCurrencyNavigationSection(mobileDataInsideLeftPane, localeObj, currencyObj, onLocaleMenuClick, onCurrencyMenuClick, defaultLoc && defaultLoc.icon, defaultCurr && defaultCurr.icon, translationsData, showLocale, showCurrency)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocale, selectedCurrency, color, showLocale, showCurrency]);

  var onOptionPressHandler = function onOptionPressHandler(val) {
    if (selectedMenu === _constants.LOCALE_LABEL) {
      setSelectedLocale(val);
      handleLocaleChange(val);

      if (fireGtm && eventLabelLocale) {
        var oldLocale = _utilities.default.getLocaleCode(selectedLocale);

        var newLocale = _utilities.default.getLocaleCode(val);

        var newData = eventLabelLocale.replace('{{oldlocale}}', oldLocale).replace('{{newlocale}}', newLocale);
        fireGtm(newData);
      }
    } else if (selectedMenu === _constants.CURRENCY_LABEL) {
      setSelectedCurrency(val);
      handleCurrencyChange(val);

      if (fireGtm && eventLabelCurrency) {
        var _newData = eventLabelCurrency.replace('{{oldcurrency}}', selectedCurrency.toLowerCase()).replace('{{newcurrency}}', val.toLowerCase());

        fireGtm(_newData);
      }
    }

    closeMobileDropdown();
  };

  var mobileHeaderWidgets = [];

  var childrenArray = _react.default.Children.toArray(children);

  var hamburgerData = [hamburgerNavigation];

  if (mobileHeaderComps.length > 0) {
    mobileHeaderWidgets = childrenArray.filter(function (child) {
      return mobileHeaderComps.find(function (widget) {
        return widget.id === child.props.id;
      });
    });
  }

  if (showLocale || showCurrency) {
    hamburgerData.push(hamburgerLocaleCurrency);
  }

  var handleIconClick = function handleIconClick(e) {
    e.preventDefault();

    if (window !== 'undefined') {
      window.history.back();
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, customOTAHeaderEnabled ? /*#__PURE__*/_react.default.createElement(OTAMobileHeader, {
    background: background,
    data: data
  }, /*#__PURE__*/_react.default.createElement(_MobileHeaderNavigationMenu.default, {
    data: OTAHeaderData.data,
    tripType: OTAHeaderData.tripType,
    translation: OTAHeaderData.translation,
    editTextCallback: handleOTAEditCTA,
    isMobile: true,
    backIconCallback: OTABackIconCallback,
    currencyCallback: onCurrencyMenuClick,
    headerTextLimit: headerTextLimit,
    boxShadow: hasBoxShadow
  }), login && renderLoginComponent(data, login.label, login.iconName, theme, accessible, locale, currency, viewport, environment, setLoginConfigForCurrency(loginConfig, true), _constants.DIRECTION.LEFT, onUserLoginStatus, '', '', secretKey, getInfoConfigTokens, move, jwtToken), menuClick && /*#__PURE__*/_react.default.createElement(MobileLocaleCurrencyContainer, {
    ref: mobileDropdownRef
  }, /*#__PURE__*/_react.default.createElement(_MobileDropdown.default, {
    sections: mobileDropdownSections,
    headerLabel: mobileDropdownHeaderLabel,
    theme: theme,
    onHeaderIconClick: closeMobileDropdown,
    onOptionPress: onOptionPressHandler,
    defaultSelectedOption: defaultSelectedOption,
    headerConfig: {
      iconColor: color,
      labelColor: color
    },
    idConfig: {
      parentName: 'universalHeader'
    },
    customProperties: {
      dropdown: {
        id: 'header-mobile-header-modal'
      }
    }
  }))) : /*#__PURE__*/_react.default.createElement(MobileHeader, {
    background: background,
    data: data
  }, /*#__PURE__*/_react.default.createElement(MobileHeaderItem, {
    justifyContent: "flex-start"
  }, customHeadingEnabled ? /*#__PURE__*/_react.default.createElement(CustomHeadingContainer, null, /*#__PURE__*/_react.default.createElement(CustomHeadingIcon, {
    onClick: function onClick(e) {
      return handleIconClick(e);
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: color,
    fontsize: "titleNormal",
    theme: theme,
    icon: data.components[0].data[0].iconName
  })), /*#__PURE__*/_react.default.createElement(CustomHeadingBody, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "default",
    theme: theme,
    bold: true
  }, customHeading)), login && renderLoginComponent(data, login.label, login.iconName, theme, accessible, locale, currency, viewport, environment, setLoginConfigForCurrency(loginConfig, true), _constants.DIRECTION.LEFT, onUserLoginStatus, '', '', secretKey, getInfoConfigTokens, move, jwtToken)) : /*#__PURE__*/_react.default.createElement(_HamburgerMenu.default, {
    data: hamburgerData,
    theme: theme,
    accessible: accessible,
    menuIconConfig: {
      color: color
    },
    leftIconConfig: {
      color: color
    },
    textConfig: {
      color: color
    },
    fireGtm: fireGtm,
    idConfig: {
      parentName: 'universalHeader'
    }
  }), menuClick && /*#__PURE__*/_react.default.createElement(MobileLocaleCurrencyContainer, {
    ref: mobileDropdownRef
  }, /*#__PURE__*/_react.default.createElement(_MobileDropdown.default, {
    sections: mobileDropdownSections,
    headerLabel: mobileDropdownHeaderLabel,
    theme: theme,
    onHeaderIconClick: closeMobileDropdown,
    onOptionPress: onOptionPressHandler,
    defaultSelectedOption: defaultSelectedOption,
    headerConfig: {
      iconColor: color,
      labelColor: color
    },
    idConfig: {
      parentName: 'universalHeader'
    },
    customProperties: {
      dropdown: {
        id: 'header-mobile-header-modal'
      }
    }
  }))), customHeadingEnabled ? null : /*#__PURE__*/_react.default.createElement(MobileHeaderItem, {
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(ImageContainer, {
    id: "".concat(dynamicID, "-left"),
    onClick: function onClick(e) {
      return handleImageClick(e, logo.newTab, logo.redirectUrl);
    },
    key: "leftImageContainer"
  }, renderHeaderLogo(theme, logo.iconUrl, accessible, background, logoWidth, logoHeight))), customHeadingEnabled ? /*#__PURE__*/_react.default.createElement(MobileHeaderItem, {
    justifyContent: "flex-end"
  }) : /*#__PURE__*/_react.default.createElement(MobileHeaderItem, {
    justifyContent: "flex-end"
  }, mobileHeaderWidgets.length > 0 && /*#__PURE__*/_react.default.createElement(MobileHeaderItem, {
    justifyContent: "flex-end"
  }, mobileHeaderWidgets.map(function (Widget) {
    return Widget;
  })), login && renderLoginComponent(data, login.label, login.iconName, theme, accessible, locale, currency, viewport, environment, setLoginConfigForCurrency(loginConfig, changeCurrency), _constants.DIRECTION.LEFT, onUserLoginStatus, '', '', secretKey, getInfoConfigTokens, move, jwtToken), changeCurrency &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  _react.default.createElement(_Link.default, {
    accessible: accessible,
    theme: theme // eslint-disable-next-line no-script-url
    ,
    href: "javascript:void(0)",
    target: "callback",
    callback: onCurrencyMenuClick,
    customProperties: {
      id: 'uhf-mobile-change-currency'
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: true,
    color: "primary",
    fontsize: "titleNormal",
    icon: "ChangeCurrency"
  })))));
};

var DesktopUniversalHeader = function DesktopUniversalHeader(props) {
  var theme = props.theme,
      children = props.children,
      data = props.data,
      leftComponents = props.leftComponents,
      rightComponents = props.rightComponents,
      accessible = props.accessible,
      background = props.background,
      color = props.color,
      locale = props.locale,
      currency = props.currency,
      viewport = props.viewport,
      loginConfig = props.loginConfig,
      environment = props.environment,
      skipSelector = props.skipSelector,
      onUserLoginStatus = props.onUserLoginStatus,
      fireGtm = props.fireGtm,
      gtmParameters = props.gtmParameters,
      showCurrency = props.showCurrency,
      showLocale = props.showLocale,
      customPadding = props.customPadding,
      idConfig = props.idConfig,
      showSkipContent = props.showSkipContent,
      isScrollTop = props.isScrollTop,
      logoWidth = props.logoWidth,
      logoHeight = props.logoHeight,
      secretKey = props.secretKey,
      getInfoConfigTokens = props.getInfoConfigTokens,
      move = props.move,
      jwtToken = props.jwtToken;
  var content = skipSelector.content,
      footer = skipSelector.footer;

  var childrenArray = _react.default.Children.toArray(children);

  var _ref12 = idConfig || {},
      parentName = _ref12.parentName,
      widgetName = _ref12.widgetName,
      index = _ref12.index;

  var _useState19 = (0, _react.useState)('universalHeader'),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      dynamicID = _useState20[0],
      setId = _useState20[1];

  (0, _react.useEffect)(function () {
    var url = 'universalHeader';

    if (parentName) {
      url = "".concat(parentName, "-universalHeader");
    }

    if (index) {
      url += "-".concat(index);
    }

    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }

    setId(url);
  }, [widgetName, parentName, index]);

  var moduleGeneratorDesktop = function moduleGeneratorDesktop(arr, leftSide) {
    return arr.map(function (element) {
      switch (element.type) {
        case _constants.HEADER_COMPONENTS.LOGO:
          return leftSide ? /*#__PURE__*/_react.default.createElement(LeftModule, {
            key: element.id
          }, /*#__PURE__*/_react.default.createElement(ImageContainer, {
            id: "".concat(dynamicID, "-left"),
            onClick: function onClick(e) {
              return handleImageClick(e, element.newTab, element.redirectUrl);
            },
            key: "leftImageContainer"
          }, renderHeaderLogo(theme, element.iconUrl, accessible, background, logoWidth, logoHeight))) : /*#__PURE__*/_react.default.createElement(RightModule, {
            key: element.id
          }, /*#__PURE__*/_react.default.createElement(ImageContainer, {
            id: "".concat(dynamicID, "-right"),
            onClick: function onClick(e) {
              return handleImageClick(e, element.newTab, element.redirectUrl);
            },
            key: "rightImageContainer"
          }, renderHeaderLogo(theme, element.iconUrl, accessible, background, logoWidth, logoHeight)));

        case _constants.HEADER_COMPONENTS.NAVIGATION:
          return leftSide ? /*#__PURE__*/_react.default.createElement(LeftModule, {
            key: element.id
          }, renderDesktopNavLink(element.redirectUrl, element.label, accessible, color, element.id, fireGtm, element.callback)) : /*#__PURE__*/_react.default.createElement(RightModule, {
            key: element.id
          }, renderDesktopNavLink(element.redirectUrl, element.label, accessible, color, element.id, fireGtm, element.callback));

        case _constants.HEADER_COMPONENTS.CUSTOM_COMPONENTS:
          {
            var found = childrenArray.find(function (obj) {
              return obj.props.id === element.id;
            });

            if (found) {
              return leftSide ? /*#__PURE__*/_react.default.createElement(LeftModule, {
                key: element.id
              }, found) : /*#__PURE__*/_react.default.createElement(RightModule, {
                key: element.id
              }, found);
            }

            return null;
          }

        case _constants.HEADER_COMPONENTS.LOCALE_CURRENCY:
          return (showLocale || showCurrency) && (leftSide ? /*#__PURE__*/_react.default.createElement(LeftModule, {
            key: element.id
          }, renderLocaleCurrency(theme, data, locale, currency, accessible, _constants.DIRECTION.LEFT, viewport, element.iconName, color, showCurrency, showLocale, fireGtm, gtmParameters, move)) : /*#__PURE__*/_react.default.createElement(RightModule, {
            key: element.id
          }, renderLocaleCurrency(theme, data, locale, currency, accessible, _constants.DIRECTION.RIGHT, viewport, element.iconName, color, showCurrency, showLocale, fireGtm, gtmParameters, move)));

        case _constants.HEADER_COMPONENTS.LOGIN:
          return leftSide ? /*#__PURE__*/_react.default.createElement(LeftModule, {
            key: element.id
          }, renderLoginComponent(data, element.label, element.iconName, theme, accessible, locale, currency, viewport, environment, loginConfig, _constants.DIRECTION.LEFT, onUserLoginStatus, isScrollTop, '', secretKey, getInfoConfigTokens, move, jwtToken)) : /*#__PURE__*/_react.default.createElement(RightModule, {
            key: element.id
          }, renderLoginComponent(data, element.label, element.iconName, theme, accessible, locale, currency, viewport, environment, loginConfig, _constants.DIRECTION.RIGHT, onUserLoginStatus, isScrollTop, '', secretKey, getInfoConfigTokens, move, jwtToken));

        default:
          return null;
      }
    });
  };

  var renderA11YSkipContent = function renderA11YSkipContent(label, selector) {
    var keyDownHandler = function keyDownHandler(slctor) {
      var element = document.querySelector("".concat(slctor, " [tabindex=\"0\"]"));

      if (element) {
        element.focus();
      }
    };

    return /*#__PURE__*/_react.default.createElement(A11ySkipContent, {
      background: background,
      color: color
    }, /*#__PURE__*/_react.default.createElement(_Title.default, {
      type: "h2",
      customProperties: {
        'aria-label': label,
        onKeyDown: function onKeyDown(e) {
          return _utilities.default.keyDownHandler(e, function () {
            return keyDownHandler(selector);
          }, _constant2.KEY_CODE.ENTER);
        }
      },
      accessible: accessible
    }, label));
  };

  return /*#__PURE__*/_react.default.createElement(Container, {
    background: background,
    customPadding: customPadding
  }, /*#__PURE__*/_react.default.createElement(LeftContainer, null, moduleGeneratorDesktop(leftComponents, true), showSkipContent && renderA11YSkipContent('Skip to content', content), showSkipContent && renderA11YSkipContent('Skip to footer', footer)), /*#__PURE__*/_react.default.createElement(RightContainer, null, moduleGeneratorDesktop(rightComponents, false)));
};

var UniversalHeader = function UniversalHeader(props) {
  var theme = props.theme,
      children = props.children,
      data = props.data,
      background = props.background,
      color = props.color,
      accessible = props.accessible,
      viewport = props.viewport,
      customProperties = props.customProperties,
      locale = props.locale,
      currency = props.currency,
      loginConfig = props.loginConfig,
      environment = props.environment,
      skipSelector = props.skipSelector,
      onUserLoginStatus = props.onUserLoginStatus,
      fireGtm = props.fireGtm,
      showCurrency = props.showCurrency,
      showLocale = props.showLocale,
      showChangeCurrency = props.showChangeCurrency,
      autoViewportOnLoad = props.autoViewportOnLoad,
      customHeadingEnabled = props.customHeadingEnabled,
      customHeading = props.customHeading,
      customOTAHeaderEnabled = props.customOTAHeaderEnabled,
      OTAHeaderData = props.OTAHeaderData,
      OTABackIconCallback = props.OTABackIconCallback,
      customPadding = props.customPadding,
      showSkipContent = props.showSkipContent,
      isScrollTop = props.isScrollTop,
      logoWidth = props.logoWidth,
      logoHeight = props.logoHeight,
      hideUHF = props.hideUHF,
      monitorWebVital = props.monitorWebVital,
      getInfoConfigTokens = props.getInfoConfigTokens,
      headerTextLimit = props.headerTextLimit,
      hasBoxShadow = props.hasBoxShadow,
      move = props.move,
      jwtToken = props.jwtToken;
  var components = data.components,
      gtmParameters = data.gtmParameters,
      secretKey = data.secretKey;
  var gtmParams = gtmParameters || _constants.DEFAULT_GTM_PARAMS;
  var event = gtmParams.event,
      eventActionClick = gtmParams.eventActionClick,
      eventCategory = gtmParams.eventCategory;
  var comp = components.find(function (el) {
    return el.data;
  }).data;

  var _useState21 = (0, _react.useState)(autoViewportOnLoad ? null : viewport),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      deviceType = _useState22[0],
      setDeviceType = _useState22[1];

  var customFilter = function customFilter(arr) {
    var leftComponents = [];
    var rightComponents = [];
    var mobileDataInsideLeftPane = [];

    for (var i = 0; i < arr.length; i += 1) {
      var _arr$i = arr[i],
          direction = _arr$i.direction,
          showInMobilePane = _arr$i.showInMobilePane;

      if (direction === _constants.DIRECTION.LEFT) {
        leftComponents.push(arr[i]);
      } else {
        rightComponents.push(arr[i]);
      }

      if (showInMobilePane === 'TRUE') mobileDataInsideLeftPane.push(arr[i]);
    }

    return {
      leftComponents: leftComponents,
      rightComponents: rightComponents,
      mobileDataInsideLeftPane: mobileDataInsideLeftPane
    };
  };

  var updateMedia = function updateMedia() {
    if (typeof window !== 'undefined') {
      setDeviceType(window.innerWidth < _constants.DESKTOP_BREAKPOINT ? _constant.DEVICE_TYPE.MOBILE : _constant.DEVICE_TYPE.DESKTOP);
    }
  };

  var setLoginTooltipShowedSession = function setLoginTooltipShowedSession() {
    if (typeof document !== 'undefined') {
      _universalheader2.default.createCookie(_constants.LOGIN_TOOLTIP_SHOWED_SESSION_LABEL, 'true');
    }
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      _universalheader2.default.createCookie(_constants.CURRENCY_COOKIE_LABEL, currency, _constants.LOCAL_CURRENCY_EXPIRY);

      _universalheader2.default.createCookie(_constants.LOCALE_COOKIE_LABEL, locale, _constants.LOCAL_CURRENCY_EXPIRY);

      if (autoViewportOnLoad) {
        updateMedia();
      }

      window.addEventListener('resize', updateMedia);
      window.addEventListener('tooltipOpened', setLoginTooltipShowedSession, {
        once: true
      });
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', updateMedia);
        window.removeEventListener('tooltipOpened', setLoginTooltipShowedSession, {
          once: true
        });
      }
    };
  }, [autoViewportOnLoad, currency, locale]);

  var fireGtmHandler = function fireGtmHandler(gtmLabel) {
    if (!fireGtm) {
      return;
    }

    var obj = {
      event: event,
      'eventDetails.category': eventCategory,
      'eventDetails.action': eventActionClick,
      'eventDetails.label': gtmLabel
    };
    fireGtm(obj, 'true');
  };

  var _customFilter = customFilter(comp),
      leftComponents = _customFilter.leftComponents,
      rightComponents = _customFilter.rightComponents,
      mobileDataInsideLeftPane = _customFilter.mobileDataInsideLeftPane;

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var onUserLoginStatusHandler = function onUserLoginStatusHandler(isLogin) {
    if (onUserLoginStatus) {
      onUserLoginStatus(isLogin);
    }
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hideUHF ? renderLoginComponent(data, '', '', theme, accessible, locale, currency, viewport, environment, loginConfig, _constants.DIRECTION.LEFT, onUserLoginStatus, null, true, secretKey, getInfoConfigTokens, move, jwtToken) : null, monitorWebVital && /*#__PURE__*/_react.default.createElement(_WebVitalRUM.default, {
      fireGtm: fireGtm
    }), !hideUHF && deviceType === _constant.DEVICE_TYPE.DESKTOP ? /*#__PURE__*/_react.default.createElement(DesktopUniversalHeader, (0, _extends2.default)({
      theme: theme,
      jwtToken: jwtToken,
      leftComponents: leftComponents,
      rightComponents: rightComponents,
      accessible: accessible,
      background: background,
      color: color,
      locale: locale,
      currency: currency,
      data: data,
      viewport: deviceType,
      loginConfig: loginConfig,
      environment: environment,
      skipSelector: skipSelector
    }, customProperties, {
      onUserLoginStatus: onUserLoginStatusHandler,
      gtmParameters: gtmParams,
      fireGtm: fireGtmHandler,
      showLocale: showLocale,
      showCurrency: showCurrency,
      customPadding: customPadding,
      showSkipContent: showSkipContent,
      isScrollTop: isScrollTop,
      logoWidth: logoWidth,
      logoHeight: logoHeight,
      secretKey: secretKey,
      getInfoConfigTokens: getInfoConfigTokens,
      move: move
    }), children) : !hideUHF && /*#__PURE__*/_react.default.createElement(MobileUniversalHeader, (0, _extends2.default)({
      theme: theme,
      jwtToken: jwtToken,
      accessible: accessible,
      background: background,
      color: color,
      locale: locale,
      currency: currency,
      data: data,
      viewport: deviceType,
      mobileDataInsideLeftPane: mobileDataInsideLeftPane,
      loginConfig: loginConfig,
      environment: environment
    }, customProperties, {
      onUserLoginStatus: onUserLoginStatusHandler,
      gtmParameters: gtmParams,
      fireGtm: fireGtmHandler,
      showLocale: showLocale,
      showCurrency: showCurrency,
      showChangeCurrency: showChangeCurrency,
      customHeadingEnabled: customHeadingEnabled,
      customHeading: customHeading,
      customOTAHeaderEnabled: customOTAHeaderEnabled,
      OTAHeaderData: OTAHeaderData,
      OTABackIconCallback: OTABackIconCallback,
      logoWidth: logoWidth,
      logoHeight: logoHeight,
      secretKey: secretKey,
      getInfoConfigTokens: getInfoConfigTokens,
      headerTextLimit: headerTextLimit,
      hasBoxShadow: hasBoxShadow,
      move: move
    }), children));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

UniversalHeader.propTypes = _universalheader.UniversalheaderProptypes.PropTypes;
UniversalHeader.defaultProps = _universalheader.UniversalheaderProptypes.DefaultProps;
MobileUniversalHeader.propTypes = _universalheader.MobileUniversalHeaderPropTypes.PropTypes;
DesktopUniversalHeader.propTypes = _universalheader.DesktopUniversalHeaderPropTypes.PropTypes;
var _default = UniversalHeader;
exports.default = _default;